import { CustomTooltip, FullScreenModal, MediumScreenModel } from "components";
import { CommercialUserProfileProps, CommercialUserProps } from "../../state/actionType";
import { EditIcon } from "assets";
import { useState } from "react";
import HandleUpdateCommercialUser from "../manage_commercial_user/HandleUpdateCommercialUser";

interface Props {
  user: CommercialUserProps;
  profile: CommercialUserProfileProps;
}
const PreviewCommercialUserDetails:React.FC<Props> = ({ user, profile })  =>{
    const [openEdit, setOpenEdit] = useState(false);
    return(
        <>
         <div className=" max-w-4xl mx-auto">
      {/* Profile Picture */}
        <div className="my-6 flex flex-col w-32">
          <div className="w-32 h-32 rounded-full border bg-primary-400 shadow-md flex items-center justify-center text-primary-900 text-7xl font-bold">
            {profile?.name?.toUpperCase().charAt(0)}
          </div>
          <div className="flex items-center justify-center mt-2">
            <p className="text-xs text-gray-500 text-center">Edit User Detail</p>
            <CustomTooltip title="Edit user" placement="right">
              <button onClick={() => setOpenEdit(true)}>
                <EditIcon className="size-4 ml-1 text-primary-400 hover:text-primary-700" />
              </button>
            </CustomTooltip>
          </div>
        </div>
      <h1 className="text-2xl font-semibold text-gray-800 mb-6">
        User Information
      </h1>
      {/* User Account Info */}
      <div className="bg-primary-50 shadow-md rounded-xl p-6 mb-6">
        <h2 className="text-lg font-semibold text-primary-600 mb-4">
          Account Details
        </h2>
        <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
          <InfoRow label="ID" value={user?.id} />
          <InfoRow label="Email" value={user?.email} />
          <InfoRow label="Mobile No." value={user?.mobile_no} />
          <InfoRow label="User Identifier" value={user?.user_identifier} />
        </div>
      </div>

      {/* Profile Info */}
      <div className="bg-primary-50 shadow-md rounded-xl p-6">
        <h2 className="text-lg font-semibold text-primary-600 mb-4">
          Profile Details
        </h2>
        <div className="grid grid-cols-2 gap-4 text-sm text-gray-700">
          <InfoRow label="Name" value={profile?.name} />
          <InfoRow label="Gender" value={profile?.gender} />
        </div>
      </div>
      {openEdit && (
        <MediumScreenModel showModal={openEdit} setShowModal={setOpenEdit}>
          <HandleUpdateCommercialUser onClose={()=>setOpenEdit(false)} commercialUserData={user} />
        </MediumScreenModel>
      )}
    </div>
        </>
    )
};
interface InfoRowProps {
  label: string;
  value: string;
}
const InfoRow: React.FC<InfoRowProps> = ({ label, value }) => (
  <div className="flex flex-col">
    <span className="text-gray-500 font-medium">{label}</span>
    <span className="text-gray-800 break-all">{value || "—"}</span>
  </div>
);

export default PreviewCommercialUserDetails;